import { ChakraProvider, Grid, extendTheme } from '@chakra-ui/react'
import SimpleSidebar from './components/Layout'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Clients from './pages/Clients'
import Dashboard from './pages/Dashboard'
import Proposals from './pages/Proposals'
import Projects from './pages/Projects'
import Resources from './pages/Resources'
import { ConvexProvider, ConvexReactClient } from 'convex/react'
import clientConfig from './convex/_generated/clientConfig'
import Proposal from './pages/Proposal'

const convex = new ConvexReactClient(clientConfig)

const theme = extendTheme({
  config: {
    useSystemColorMode: true,
    initialColorMode: 'dark'
  }
})

export const App = () => (
  <ConvexProvider client={convex}>
    <BrowserRouter>
      <ChakraProvider theme={theme}>
        <SimpleSidebar>
          <Grid>
            <Routes>
              <Route path="/"
                element={<Dashboard/>}/>
              <Route path="/proposals"
                element={<Proposals/>}/>
              <Route path="/proposals/:id"
                element={<Proposal/>}/>
              <Route path="/projects"
                element={<Projects/>}/>
              <Route path="/resources"
                element={<Resources/>}/>
              <Route path="/clients"
                element={<Clients/>}/>
            </Routes>
          </Grid>
        </SimpleSidebar>
      </ChakraProvider>
    </BrowserRouter>
  </ConvexProvider>
)
